/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import log from 'loglevel';

import { Box } from '@material-ui/core';

import PageContainer from 'components/PageContainer';

import styles from './styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import ActionButtonContainer from 'components/ActionButtonsContainer';
import CancelButton from 'features/CancelButton';
import Button from 'components/Button';

type PropTypes = WithTranslation;
interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<PropTypes, State> {
  public constructor(props: PropTypes) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static getDerivedStateFromError(error: any): State {
    log.error(error);
    return { hasError: true };
  }

  public render(): React.ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const { t } = this.props;

    return (
      <Box mt={8}>
        <Box mb={2}>
          <h1 css={styles.titleText}>{t('genericError.errorTitle')}</h1>
        </Box>

        <PageContainer>
          <Box mb={2}>
            <h2 css={styles.subtitleText}>{t('genericError.title')}</h2>
          </Box>

          <p css={styles.normalText}>{t('genericError.errorMessage')}</p>

          <Box mt={5}>
            <ActionButtonContainer>
              <Button component="a" href="/">
                {t('genericError.startOverButton')}
              </Button>
              <CancelButton />
            </ActionButtonContainer>
          </Box>
        </PageContainer>
      </Box>
    );
  }
}

// This component cannot have override because the error can be anywhere in the
// app and the tenant data may not be available.
export default withTranslation()(ErrorBoundary);
